// extracted by mini-css-extract-plugin
export var jobBlock = "jobs-module--job-block--baf49";
export var jobContent = "jobs-module--job-content--16115";
export var jobList = "jobs-module--job-list--679c3";
export var jobsGrid = "jobs-module--jobs-grid--16f6e";